'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002421 from "./presto.-Agent-View$$anon$21.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002423 from "./presto.-Agent-View$$anon$23.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$20() {
  this.axk = null;
  this.axc = null;
  this.axd = false;
  this.axl = null;
  this.axm = false;
  this.axp = null;
  this.axi = null;
  this.axj = false;
  this.axe = null;
  this.axf = false;
  this.axg = null;
  this.axh = false;
  this.axn = false;
  this.axo = false;
  this.axk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axp = "LocalPjeOfficeSignFileRequest";
}
export { $c_Lpresto_AgentView$$anon$20 as $c_Lpresto_AgentView$$anon$20 };
$p = $c_Lpresto_AgentView$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$20;
/** @constructor */
function $h_Lpresto_AgentView$$anon$20() {
}
export { $h_Lpresto_AgentView$$anon$20 as $h_Lpresto_AgentView$$anon$20 };
$h_Lpresto_AgentView$$anon$20.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.axk;
});
$p.L = (function() {
  if ((!this.axd)) {
    this.axc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axd = true;
  }
  return this.axc;
});
$p.O = (function() {
  if ((!this.axm)) {
    this.axl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axm = true;
  }
  return this.axl;
});
$p.E = (function() {
  return this.axp;
});
$p.t = (function() {
  if ((!this.axj)) {
    this.axi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("encoding", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("encapsulate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.axj = true;
  }
  return this.axi;
});
$p.M = (function() {
  if ((!this.axf)) {
    this.axe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002421.$c_Lpresto_AgentView$$anon$21())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.axf = true;
  }
  return this.axe;
});
$p.Q = (function() {
  if ((!this.axh)) {
    this.axg = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002423.$c_Lpresto_AgentView$$anon$23();
    this.axh = true;
  }
  return this.axg;
});
$p.w = (function() {
  if ((!this.axo)) {
    this.axn = false;
    this.axo = true;
  }
  return this.axn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee153) => ((p) => \u03b4scrutinee153.cFW(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignFileRequest$())));
});
var $d_Lpresto_AgentView$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$20, "presto.AgentView$$anon$20", ({
  DK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$20 as $d_Lpresto_AgentView$$anon$20 };
//# sourceMappingURL=presto.-Agent-View$$anon$20.js.map
